export default customElements.define('w-formgroup-v2', class FormgroupV2 extends wealthify.CustomElementBaseClass {

    constructor() {
        const styleSelector = 'c-formgroup-v2';
        const config = {
            styleSelector,
            templateHTML: `
            <div class="${styleSelector}__container" data-root>
                <label class="${styleSelector}__label" data-label>
                    <w-widget-button small="true" label="More information" class="${styleSelector}__label-more-button" icon="info" hidden data-morebutton></w-widget-button>
                </label>
                <p class="${styleSelector}__pre-label" data-prelabel hidden></p>
                <span data-slot="input" class="${styleSelector}__input" data-input></span>
                <p class="${styleSelector}__sub-label" data-sublabel hidden></p>
                <w-message class="${styleSelector}__error u-display__none u-margin__bottom-mobile--0" data-error></w-message>
                <span data-slot="modal" data-modal></span>
            </fieldset>`,
            cacheDom: [ 'data-label', 'data-prelabel', 'data-sublabel', 'data-error', 'data-input', 'data-modal', 'data-morebutton' ],
            defaultSlotContents: {input: '<w-textbox data-slot="input"></w-textbox>'},
        };

        super(config);

        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);

            document.addEventListener('DOMContentLoaded', () => this.dispatchEvent(new Event('fieldadded')));

            this._assignInputValue();
            this._addLabelForAttribute();
            this._eventBindCallbacks.valuechange();
            this._eventBindCallbacks.validchange();

            this.dom.input.getWrappingComponent = () => this;

            if (this.erroronblur) {
                this._eventBindCallbacks.blur();
            }

            this._setupModal();
        };
    }

    static get validLayouts () {
        return [
            'stacked', 'inline'
        ];
    }

    static get observedProps () {
        return [
            new wealthify.Prop('erroronblur', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('label', {required: true}),
            new wealthify.Prop('layout', {
                default: 'stacked',
                type: wealthify.propTypes.ArrayItem(this.validLayouts)
            }),
            new wealthify.Prop('prelabel'),
            new wealthify.Prop('sublabel'),
            new wealthify.Prop('error'),
            new wealthify.Prop('warning'),
            new wealthify.Prop('readonlyprop', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            wealthify.props.DarkMode()
        ];
    }

    get propCallbacks () {
        return {
            erroronblur: () => {},
            label: (value) => {
                this.dom.label.firstChild.textContent = value;
                
                if (this.prelabel) {
                    this.dom.label.classList.add(`${this.styleSelector}__label--with-pre-label`);
                }
            },
            layout: (value) => {
                this.constructor.validLayouts.forEach((key) => {
                    this.dom.root.classList.remove(`${this.styleSelector}--${key}`);
                });

                this.dom.root.classList.add(`${this.styleSelector}--${value}`);
                this.dom.label.classList.add(`${this.styleSelector}__label--${value}`);
                this.dom.sublabel.classList.add(`${this.styleSelector}__sub-label--${value}`);
                this.dom.input.classList.add(`${this.styleSelector}__input--${value}`);
                this.dom.error.classList.add(`${this.styleSelector}__error--${value}`);
            },
            sublabel: (value) => this._hideShowLabel('sublabel', value),
            readonlyprop: (value) => { 
                const classListAction = value ? 'add' : 'remove';
        
                this.dom.root.classList[classListAction](`${this.styleSelector}--readonly`);
                this.dom.label.classList[classListAction](`${this.styleSelector}__label--readonly`);
                this.dom.input.readonlyprop = value;
            },
            prelabel: (value) => {
                if (this.layout === 'inline') {
                    return;
                }

                this._hideShowLabel('prelabel', value);
            },
            error: () => {
                // added in event so that error is announced by assistive
            },
            warning: () => {
                // added in event so that warning is announced by assistive
            },
        };
    }

    _hideShowLabel (label, value) {
        if (value === '') {
            this.dom[label].hidden = '';
        } else {
            this.dom[label].removeAttribute('hidden');
        }

        this.dom[label].innerHTML = value;
    }

    _setupModal () {
        // TODO - Consider during slot refactor (PDB-1008)
        if (this.dom.modal.tagName.toLowerCase() !== 'span') {
            this.dom.morebutton.onclickprop = (() => {
                this.dom.modal.open = true;
            }).bind(this);
            this.dom.label.classList.add(`${this.styleSelector}__label--with-modal`);
            this.dom.morebutton.removeAttribute('hidden');
        }
    }

    _assignInputValue () {
        this.valid = this.dom.input.valid;
        this.value = this.dom.input.value;
    }

    _addLabelForAttribute () {
        let inputId = this.dom.input.getAttribute('key');

        if (inputId === null) {
            this.dom.input.setAttribute('key', wealthify.type.number.getRandom(10));
            inputId = this.dom.input.getAttribute('key');
        }

        const errorId = `${inputId}-error`;
        const subLabelId = `${inputId}-sub-label`;

        this.dom.label.setAttribute('for', inputId);
        this.dom.error.id = errorId;
        this.dom.sublabel.id = subLabelId;

        this.dom.input.setAttribute('aria-describedby', `${subLabelId} ${errorId}`);
    }

    _toggleErrorMessage() {
        const hasMessage = this.dom.input.hasWarning || !this.dom.input.valid;

        if (hasMessage) {
            const message = this.dom.input.hasWarning ? this.warning : this.error;
            const type = this.dom.input.hasWarning ? 'warning' : 'error';

            if (message == undefined) {
                return;
            }

            this.dom.error.classList.remove('u-display__none');
            this.dom.error.label = message;
            this.dom.error.type = type;
        } else {
            this.dom.error.label = '';
            this.dom.error.classList.add('u-display__none');
        }
    }

    _eventBindCallbacks = {
        valuechange: () => {
            this.dom.root.addEventListener('valuechange', () => {
                if (!this.erroronblur) {
                    this._toggleErrorMessage();
                }
                this._assignInputValue();
            });  
        },

        validchange: () => {
            this.dom.root.addEventListener('validchange', () => {
                if (!this.erroronblur) {
                    this._toggleErrorMessage();
                }
                this._assignInputValue();
            });
        },

        blur: () => {
            this.dom.root.addEventListener('focusout', () => {
                this._toggleErrorMessage();
            });
        }
    }

});